/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getItemDisputationTypesList } from '../fn/item-disputation-type-controller/get-item-disputation-types-list';
import { GetItemDisputationTypesList$Params } from '../fn/item-disputation-type-controller/get-item-disputation-types-list';
import { ItemDisputationTypeWithRelations } from '../models/item-disputation-type-with-relations';

@Injectable({ providedIn: 'root' })
export class ItemDisputationTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemDisputationTypeControllerGetItemDisputationTypesList()` */
  static readonly ItemDisputationTypeControllerGetItemDisputationTypesListPath = '/item-disputation-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getItemDisputationTypesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItemDisputationTypesList$Response(params?: GetItemDisputationTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemDisputationTypeWithRelations>>> {
    return getItemDisputationTypesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getItemDisputationTypesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItemDisputationTypesList(params?: GetItemDisputationTypesList$Params, context?: HttpContext): Observable<Array<ItemDisputationTypeWithRelations>> {
    return this.getItemDisputationTypesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemDisputationTypeWithRelations>>): Array<ItemDisputationTypeWithRelations> => r.body)
    );
  }

}
